export default __webpack_public_path__ + "static/media/thumbnail.040458ba.png";